// const key = process.env.VUE_APP_MAPTILER_KEY

export const leafletDefaults = {
  url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  maxZoom: 19,
  // url: 'https://api.maptiler.com/maps/fd7e2f6f-a622-4694-ad9b-dd1aa734f630/256/{z}/{x}/{y}.png?key=' + key,
  // url: 'https://api.maptiler.com/maps/fd7e2f6f-a622-4694-ad9b-dd1aa734f630/256/{z}/{x}/{y}.png?key=' + key,
  // attribution: '<a href="https://www.maptiler.com/copyright/" target="_blank">© MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">© OpenStreetMap contributors</a> <a href="https://carto.com/" target="_blank">© CARTO</a>',
  zoomPosition: 'bottomleft',
}
